import React from "react";
import { Datatable } from "../dataTable/Datatable";
import { Button } from "react-bootstrap";
import { BiEditAlt, BiEnvelope, BiPhone, BiPlus, BiTrash } from "react-icons/bi";
import { getClientData } from "../../utils/Common";


const columns = [
  {
    field: "PERSON_NM",
    header: "Person name",
    align: "left",
  },
  {
    field: "DESIGNATION_NM",
    header: "Designation",
    align: "left",
  },
  {
    field: "MOBILE_NO1",
    header: "Email/Mobile No",
    align: "left",
  },
  {
    field: "Action",
    header: "Action",
    align: "center",
  },
];

const ClientcontactDtl = ({ data, handleAddCustUserMdl, handleDeleteMdl }) => {

  const client = getClientData();
  // client?.CUSTOMER_CD
  return (
    <>
      <Datatable
        data={data}
        columns={columns}
        tableNm="Products & Services"
        pagination
        isSearchBar
        height={255}
        tableBtn={
          <Button
            type="button"
            variant="primary"
            className="btn-sm ms-auto text-nowrap"
            onClick={() => {
              handleAddCustUserMdl();
            }}
          >
            <BiPlus className="text-lg me-2" /> Add More
          </Button>
        }
      >
        {(child) => (
          <>
            {child.column.field === "MOBILE_NO1" && (
              <>
                <div>
                  <span className="">
                    <BiPhone className="me-2" />
                  </span>
                  <span>{child.row.MOBILE_NO1}</span>
                </div>
                <div>
                  <span className="">
                    <BiEnvelope className="me-2" />
                  </span>
                  {child.row.EMAIL_ID}
                </div>
              </>
            )}

            {child.column.field === 'Action' &&
              <div className='d-flex justify-content-center gap-2'>
                <Button
                  variant="edit"
                  title="Edit"
                  className="btn-sm rounded-circle"
                  onClick={() => {
                    handleAddCustUserMdl(child.row);
                  }}
                >
                  <BiEditAlt />
                </Button>
                {child.row.TRAN_CD !== client?.CUSTOMER_CD &&
                  <Button
                    variant="delete"
                    title="Delete"
                    className="btn-sm rounded-circle"
                    onClick={() => {
                      handleDeleteMdl(child.row)
                    }}
                  >
                    <BiTrash />
                  </Button>
                }
              </div>}

            {child.column.field !== "MOBILE_NO1" &&
              child.row[child.column.field]}
          </>
        )
        }
      </Datatable >
    </>
  );
};

export default ClientcontactDtl;
